export default __webpack_public_path__ + "static/media/NavGurukul Graphic Design Course Curriculum.9c9a5374.pdf";